// Customizable Area Start
import mitt from 'mitt';
import { CometCall } from '../../blocks/chat/src/ChatController';

type Events = {
    "incoming-call": { call: CometCall };
  };

const emitter = mitt<Events>();

export default emitter;
// Customizable Area End
